/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { useFormik } from "formik";
import { Button, UncontrolledTooltip } from "reactstrap";
import { toast } from "react-toastify";
import Timeout from "await-timeout";
import * as Yup from "yup";
import { Trash2 } from "react-feather";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { getNotasDePedidoCategory, fetchNotaDePedidoById } from "../../../services/notasDePedidoServices";
import { CustomLabel } from "../../../ui/labels";
import { InputText } from "../../../ui/inputs";
import { ButtonPrimary } from "../../../ui/buttons";
import { LabSelect } from "../../course/select";
import { validateEmail } from "../utils";

const FormNewCandidato = ({ toggle, derivacionId, notaDePedidoId, handleCreateCandidato }) => {
  const [nota] = useFetcher(fetchNotaDePedidoById, [notaDePedidoId]);
  const [portalValue, setPortalValue] = useState(null);
  const [categories, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined);
  const portales = categories.portal ? categories.portal.type : [];
  const [files, setFiles] = useState(null);
  const [fileName, setFileName] = useState("Seleccione un archivo");
  const servicioNotaDePedido = nota && nota.rows ? nota.rows[0].servicio : null;

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;

    setFileName(selectedFiles[0].name);
    setFiles(selectedFiles);
  };

  const handleDeleteCV = () => {
    setFileName("Seleccione un archivo");
    setFiles(null);
  };

  const portalesOptions = portales
    ? portales
        .map((e) => {
          return { label: e.text, value: e.text };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  function getFunctionToFilter(filter, selected) {
    if (filter === "portal") {
      setPortalValue(selected);
    }
  }
  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const inputError = () => {
    const error = { error: false };

    if (portalValue === null) {
      error.portal = "Debe seleccionar una portal.";
      error.error = true;
    } else if (portalValue.value === "" || portalValue.value === undefined) {
      error.portal = "Debe seleccionar una portal.";
      error.error = true;
    }

    return error;
  };

  const messageError = inputError();

  const formik = useFormik({
    initialValues: {
      key: "",
      notaDePedidoId,
      nombre: "",
      apellido: "",
      email: "",
      cuil: "",
      telefono: "",
      portal: "",
      estado: 1,
      // observaciones: "",
    },
    onSubmit: async (values) => {
      if (messageError.error) return;

      const dataToCreate = {
        ...values,
        telefono: values.telefono ? JSON.stringify(values.telefono) : "",
        cuil: values.cuil ? JSON.stringify(values.cuil) : "",
        portal: portalValue && portalValue.value,
        key: values.cuil.toString(),
        servicio: servicioNotaDePedido,
      };
      if (derivacionId) {
        dataToCreate.derivacionId = derivacionId;
      }

      try {
        const isCreated = await handleCreateCandidato(dataToCreate, files);
        await Timeout.set(1000);
        if (isCreated) toggle();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      nombre: Yup.string().required("Este campo es requerido."),
      apellido: Yup.string().required("Este campo es requerido."),
      email: Yup.string()
        .required("Este campo es requerido.")
        .test("is-valid-email", "Debe ingresar un correo electrónico válido", (value) => validateEmail(value)),
      cuil: Yup.string().required("Este campo es requerido."),
      telefono: Yup.string().required("Este campo es requerido."),
    }),
  });

  return (
    <>
      <form className="theme-form" onSubmit={formik.handleSubmit}>
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-sm-9">
            <div className="form-group">
              <CustomLabel htmlFor="nombre" className=" px-0 w-100">
                Nombre
                <InputText
                  // className={formik.errors.nombre && formik.touched.nombre ? "form-control error-field" : "form-control"}
                  // type="number"
                  name="nombre"
                  // placeholder="nombre"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.nombre}
                  style={formik.touched.nombre && formik.errors.nombre ? { borderBottom: "1px solid red" } : null}
                />
              </CustomLabel>
              {formik.errors.nombre && formik.touched.nombre && <CustomLabel style={{ color: "red" }}>{formik.errors.nombre}</CustomLabel>}
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <CustomLabel htmlFor="apellido" className=" px-0 w-100">
                Apellido
                <InputText
                  // className={formik.errors.apellido && formik.touched.apellido ? "form-control error-field" : "form-control"}
                  // type="number"
                  name="apellido"
                  // placeholder="apellido"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.apellido}
                  style={formik.touched.apellido && formik.errors.apellido ? { borderBottom: "1px solid red" } : null}
                />
              </CustomLabel>
              {formik.errors.apellido && formik.touched.apellido && <CustomLabel style={{ color: "red" }}>{formik.errors.apellido}</CustomLabel>}
            </div>
          </div>
          <div className="col-sm-9">
            <div className="mb-3">
              <CustomLabel htmlFor="email" className=" px-0 w-100">
                Email
                <InputText
                  // className={formik.errors.email && formik.touched.email ? "form-control error-field" : "form-control"}
                  type="email"
                  name="email"
                  // placeholder="email"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  style={formik.touched.email && formik.errors.email ? { borderBottom: "1px solid red" } : null}
                />
              </CustomLabel>
              {formik.errors.email && formik.touched.email && <CustomLabel style={{ color: "red" }}>{formik.errors.email}</CustomLabel>}
            </div>
          </div>
          <div className="col-sm-9">
            <div className="mb-3">
              <CustomLabel htmlFor="telefono" className="px-0 w-100">
                Teléfono
                <InputText
                  // className={formik.errors.telefono && formik.touched.telefono ? "form-control error-field" : "form-control"}
                  type="number"
                  name="telefono"
                  // placeholder="teléfono"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.telefono}
                  onWheel={(e) => e.target.blur()}
                  style={formik.touched.telefono && formik.errors.telefono ? { borderBottom: "1px solid red" } : null}
                />
              </CustomLabel>
              {formik.errors.telefono && formik.touched.telefono && <CustomLabel style={{ color: "red" }}>{formik.errors.telefono}</CustomLabel>}
            </div>
          </div>
          <div className="col-sm-9">
            <div className="mb-3">
              <CustomLabel htmlFor="cuil" className=" px-0 w-100">
                Cuil
                <InputText
                  // className={formik.errors.cuil && formik.touched.cuil ? "form-control error-field" : "form-control"}
                  type="number"
                  name="cuil"
                  // placeholder="ingrese cuil sin espacios ni guiones"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.cuil}
                  onWheel={(e) => e.target.blur()}
                  style={formik.touched.cuil && formik.errors.cuil ? { borderBottom: "1px solid red" } : null}
                />
              </CustomLabel>
              {formik.errors.cuil && formik.touched.cuil && <CustomLabel style={{ color: "red" }}>{formik.errors.cuil}</CustomLabel>}
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <CustomLabel htmlFor="portal" className=" px-0 w-100">
                Portal
                <LabSelect
                  id="portal"
                  name="portal"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={portalValue}
                  placeholder="Todo"
                  isClearable
                  isLoading={isLoadingCategoies}
                  isDisabled={isLoadingCategoies}
                  options={portalesOptions}
                />
              </CustomLabel>
              {messageError.portal && formik.touched.portal && (
                <CustomLabel style={{ color: "red" }} className="input-feedback">
                  {messageError.portal}
                </CustomLabel>
              )}
            </div>
          </div>

          <div className="col-sm-9">
            <div className="mb-3">
              <CustomLabel htmlFor="apellido" className=" px-0 w-100">
                Cargar CV
                <div className="d-flex align-items-center">
                  <div className="custom-file">
                    <input
                      className="custom-file-input"
                      type="file"
                      id="upfile"
                      onChange={handleFileChange}
                      accept=".pdf, .xls, .xlsx, .doc, .docx, .jpg, .jpeg, .png"
                      style={{ cursor: "pointer", border: "none" }}
                      disabled={formik.isSubmitting}
                    />
                    <CustomLabel className="custom-file-label" htmlFor="upfile">
                      {fileName}
                    </CustomLabel>
                  </div>
                  <UncontrolledTooltip placement="top" target="deleteCV">
                    Eliminar
                  </UncontrolledTooltip>
                  <Button size="xs" color="link" id="deleteCV" onClick={handleDeleteCV}>
                    <Trash2 size={18} className="ml-2" color="#293134" />
                  </Button>
                </div>
              </CustomLabel>
            </div>
          </div>
        </div>
        <div className=" mt-3 mb-0 d-flex justify-content-end">
          <Button color="btn-secondary mr-2" onClick={toggle}>
            Cancelar
          </Button>
          <ButtonPrimary disabled={formik.isSubmitting} type="submit">
            Crear Candidato
          </ButtonPrimary>
        </div>
      </form>
    </>
  );
};

export default FormNewCandidato;
